export default {
    state: {
        listen: {}
    },
    mutations: {
        setListening(state, payload) {
            state.listen = {...state.listen, ...payload};
        }
    },
    getters: {
        listen(state) {
            return state.listen;
        }
    }
}